export const caretDown = {
    path: "M99.45 6.205q0 2.55-1.785 4.42l-43.52 43.52q-1.87 1.785-4.42 1.785t-4.335-1.785l-43.52-43.52q-1.87-1.87-1.87-4.42 0-2.465 1.87-4.335t4.335-1.87l87.04 0q2.465 0 4.335 1.87t1.87 4.335z",
    width: 100,
    height: 56.239,
} as const;

export const iconChevronLeft = {
    path: "M-.013 49.84q0-3.416 2.352-5.824l41.72-41.664q2.352-2.352 5.768-2.352t5.824 2.352l4.816 4.816q2.352 2.296 2.352 5.768t-2.352 5.824l-31.136 31.08 31.136 31.08q2.352 2.408 2.352 5.824t-2.352 5.768l-4.816 4.76q-2.296 2.352-5.768 2.352t-5.824-2.352l-41.72-41.664q-2.352-2.352-2.352-5.768z",
    width: 63.069,
    height: 100,
} as const;

export const iconChevronRight = {
    path: "M62.808 49.728q0 3.36-2.352 5.88l-41.72 41.664q-2.352 2.408-5.768 2.408t-5.768-2.408l-4.872-4.76q-2.352-2.52-2.352-5.88t2.352-5.712l31.08-31.136-31.08-31.024q-2.352-2.52-2.352-5.88t2.352-5.712l4.872-4.76q2.296-2.408 5.768-2.408t5.768 2.408l41.72 41.664q2.352 2.296 2.352 5.656z",
    width: 63.034,
    height: 100,
} as const;

export const iconChevronDown = {
    path: "M99.669 13.048q0 3.36-2.352 5.712l-41.664 41.664q-2.408 2.408-5.88 2.408t-5.712-2.408l-41.664-41.664q-2.408-2.24-2.408-5.712t2.408-5.88l4.76-4.816q2.52-2.352 5.88-2.352t5.656 2.352l31.136 31.136 31.08-31.136q2.352-2.352 5.712-2.352t5.88 2.352l4.816 4.816q2.352 2.52 2.352 5.88z",
    width: 100,
    height: 63.034,
} as const;

export const iconCheck = {
    path: "M8.70710678,12.2928932 C8.31658249,11.9023689 7.68341751,11.9023689 7.29289322,12.2928932 C6.90236893,12.6834175 6.90236893,13.3165825 7.29289322,13.7071068 L9.82842712,16.2426407 C10.2207367,16.6349502 10.8574274,16.6328935 11.2471942,16.2380576 L16.7116603,10.7025237 C17.0996535,10.3094846 17.0955629,9.67633279 16.7025237,9.28833966 C16.3094846,8.90034653 15.6763328,8.90443714 15.2883397,9.29747629 L10.5309507,14.1167372 L8.70710678,12.2928932 Z",
    width: 24,
    height: 24,
} as const;

export const trophy = {
    path: "M17.20015,13.9950796 C16.3223284,15.5158964 14.7965194,16.6156427 13,16.9170416 L13,19 L15,19 C15.5522847,19 16,19.4477153 16,20 C16,20.5522847 15.5522847,21 15,21 L9,21 C8.44771525,21 8,20.5522847 8,20 C8,19.4477153 8.44771525,19 9,19 L11,19 L11,16.9170416 C9.20348058,16.6156427 7.6776716,15.5158964 6.79984999,13.9950796 C4.68369812,13.8907981 3,12.1420234 3,10 C3,8.13616057 4.27477279,6.57006028 6,6.12601749 L6,5 L5,5 C4.44771525,5 4,4.55228475 4,4 C4,3.44771525 4.44771525,3 5,3 L19,3 C19.5522847,3 20,3.44771525 20,4 C20,4.55228475 19.5522847,5 19,5 L18,5 L18,6.12601749 C19.7252272,6.57006028 21,8.13616057 21,10 C21,12.1420234 19.3163019,13.8907981 17.20015,13.9950796 Z M17.9524394,11.7590882 C18.5763712,11.4205532 19,10.7597485 19,10 C19,9.25971764 18.5978014,8.61337381 18,8.26756439 L18,11 C18,11.2571277 17.9838258,11.5104778 17.9524394,11.7590882 Z M6.04756064,11.7590882 C6.01617418,11.5104778 6,11.2571277 6,11 L6,8.26756439 C5.40219863,8.61337381 5,9.25971764 5,10 C5,10.7597485 5.42362885,11.4205532 6.04756064,11.7590882 Z M8,11 C8,13.209139 9.790861,15 12,15 C14.209139,15 16,13.209139 16,11 L16,5 L8,5 L8,11 Z",
    width: 24,
    height: 24,
} as const;

export const contentArticle = {
    path: "M18 20v-9h2v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h6v2H6v16h12zM13.5 9a.5.5 0 0 1-.5-.5V2l7 7h-6.5z",
    width: 24,
    height: 24,
} as const;

export const contentExercise = {
    path: "M12.5 7.914l-7.5 7.5V19h3.586l7.5-7.5L12.5 7.914zM13.914 6.5l3.586 3.586L19.586 8 16 4.414 13.914 6.5zM3 15a1 1 0 0 1 .293-.707l12-12a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-12 12A1 1 0 0 1 9 21H4a1 1 0 0 1-1-1v-5z",
    width: 24,
    height: 24,
} as const;

export const contentVideo = {
    path: "M17.015 12L8 6.741v10.518L17.015 12zM6 19V5a1 1 0 0 1 1.504-.864l12 7a1 1 0 0 1 0 1.728l-12 7A1 1 0 0 1 6 19z",
    width: 24,
    height: 24,
} as const;
